import React, {Component} from 'react';
import {translate} from 'react-i18next';
import BackNextButtons from './components/back_next_buttons';
import swal from 'sweetalert';
import WaitingModal from '../generics/WaitingModal';
import moment from 'moment';

var Config = require('../../config');

class SampleData extends Component{
	constructor(props){
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.showCtrlError = this.showCtrlError.bind(this);
        this.isValidForm = this.isValidForm.bind(this);
        this.save = this.save.bind(this);
        
        this.state = {
            timestamp:"",
            number:"",
            patient_bracelet:"",
            bracelet_required:""	
		}
	}

	componentDidMount(){
        fetch(Config.default.apiGateway.URL+'offers?option=militar_date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({timestamp:response});
        });
        
        //Criterio funcional "SOLICITAR PULSERA
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_BAND_REQ&x=',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
            this.setState({bracelet_required:response.value});
            if(response.value === "YES"){
                document.getElementById("patient_bracelet").required = true;
            }
		})
	}

	componentDidUpdate(){
    }
    
    handleChange(event){
		this.setState({[event.target.name] : event.target.value});
		
        var control = document.getElementById(event.target.id);
        if(control !== null){
            if(control.required && control.className.includes('error')){
                control.classList.remove('error');
            }else if(control.required && event.target.value===""){
                control.classList.add('error');
            }
        }
    }
    
    isValidForm() {
		const inputs = document.querySelectorAll('input');
	    let isFormValid = true;

	    inputs.forEach(input => {
	    	if(input.required){
    			const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}	   
		  	}
        });
        
        if(!isFormValid)
            swal('¡Error!', "Campos incompletos", 'error');
	    
	    return isFormValid;
    }
    
    showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {
			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}

		return res;
    }
    
    save(event){
        event.preventDefault();
        if(this.isValidForm()){
            var date = moment(this.state.timestamp, 'DD-MM-YYYY h:mm');
            var medical_staff = JSON.parse(sessionStorage.getItem("medical_staff"));
            var obj = {};

            obj.skip_number_generation=true;
            obj.sample = {};
            obj.patition_has_sample = {};
            obj.sample.patient_id = parseInt(this.props.match.params.patient_id,10);
            obj.sample.timestamp = date.format('MM-DD-YYYY h:mm');;
            obj.sample.taked_by = medical_staff.names + " "+medical_staff.lastname1+(medical_staff.lastname2 !== ""?(" "+medical_staff.lastname2):"");
            obj.sample.number = this.state.number;
            obj.sample.patient_bracelet = this.state.patient_bracelet;
            this.waiting_modal.handleShow('Guardando...');
            fetch(Config.default.apiGateway.URL+'samples/patient_sample?health_facilities_id='+sessionStorage.getItem("health_facilities_id"),{ 
                method: 'post',
                body: JSON.stringify(obj), 
                headers: new Headers({
                   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
                   'Accept': 'application/json',
                    'Content-Type': 'application/json',
                })
            })
            .then(res => {
                this.waiting_modal.handleClose();
                if(res.ok){
                  return res.json();
                }else{
                  res.text().then(function(result) {
                    swal('¡Error!', result, 'error');
                    return;
                  });
                }})
            .then(response => {
                if(response!==undefined){
                    this.props.history.push("/transfusional_control");
                    swal('¡Correcto!', "Muestra registrada", 'success');
                }
            });
        }
    }

	render(){
		const {t} = this.props;

		return (
            <div className="container">
                <h3>Datos de la Muestra</h3>
                <div className="col-xs-12 form-group" >
                    <div className="col-xs-12">
                        <span>Historia Clínica</span>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <input type="text" value={this.props.match.params.number || ""}  id="patient_number" name="patient_number" className="form-control"
                        readOnly/>
                    </div>
                </div>
                <div className="col-xs-12 form-group" >
                    <div className="col-xs-12">
                        <span>Fecha de Registro</span>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <input type="text" value={this.state.timestamp || ""}  id="timestamp" name="timestamp" 
                        className="form-control" onChange={this.handleChange} readOnly/>
                    </div>
                </div>
                {this.state.bracelet_required === "YES"?
                <div className="col-xs-12 form-group" >
                    <div className="col-xs-12">
                        <span>ID Pulsera Paciente</span>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <input type="text" value={this.state.patient_bracelet || ""}  id="patient_bracelet" name="patient_bracelet" 
                        className="form-control" onChange={this.handleChange}/>
                    </div>
                </div>:null}
                <div className="col-xs-12 form-group" >
                    <div className="col-xs-12">
                        <span>Muestra Número</span>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <input type="text" value={this.state.number || ""}  id="number" name="number" className="form-control"
                        onChange={this.handleChange} required/>
                    </div>
                </div>
                <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
                <BackNextButtons history={this.props.history} isValidForm={this.isValidForm} showBack={true} showSave={true} save={this.save}/>
            </div>
		)
			
	}
} 

export default translate('translations') (SampleData);